import './css/fonts.less';
import './css/style.less';
import './css/inner_page.less';
import './css/adaptive.less';
import Main from './js/main';
import Map from './js/map';
import InnerPage from './js/inner_page';
import Slider from './js/swiper';
import VideoInit from './js/video';


require('es6-promise').polyfill();

Main.Init();
if(document.querySelector('.map')){
    Map.Init();
}
InnerPage.Init();

if(document.querySelector('.swiper-container') || document.querySelector('.roses-block') || document.querySelector('.costumers__items')){
    Slider.Init();
}

const video_js = document.querySelector('.video-js');
if(video_js){
    VideoInit.Init();
}